import { render, staticRenderFns } from "./SeckillDetails.vue?vue&type=template&id=2febb9ba&scoped=true"
import script from "./SeckillDetails.vue?vue&type=script&lang=js"
export * from "./SeckillDetails.vue?vue&type=script&lang=js"
import style0 from "./SeckillDetails.vue?vue&type=style&index=0&id=2febb9ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2febb9ba",
  null
  
)

export default component.exports